const STOPWORDS = new Set([
  'advocacia', 'advogados', 'advogado', 'associados', 'sociedade',
  'escritorio', 'escritório', 'de', 'da', 'do', 'dos', 'das', 'e',
]);

/**
 * Iniciais do escritório (mesma regra do backend): duas primeiras palavras significativas,
 * ignorando "Advocacia", "Advogados", preposições etc. "Zeus e Apolo Advocacia" → "ZA".
 */
export function officeInitials(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  const words = trimmed.split(/\s+/).filter((word) => {
    const letters = word.replace(/[^\p{L}]/gu, '');
    return letters.length > 0 && !STOPWORDS.has(letters.toLowerCase());
  });
  const initials = words.slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join('');
  return initials || trimmed.slice(0, 2).toUpperCase();
}
